<template>
    <div class="w-full">
        <div class="p-4">
            <CorrectIncorrectIcon :is-correct="question.correct_answer === 'TRUE'" />
            {{ question.options.yes_no ? $t('messages.yes') : $t('messages.true') }}
        </div>

        <div class="p-4">
            <CorrectIncorrectIcon :is-correct="question.correct_answer === 'FALSE'" />
            {{ question.options.yes_no ? $t('messages.no') : $t('messages.false') }}
        </div>
    </div>
</template>

<script>
import CorrectIncorrectIcon from '@/components/Quiz/CorrectIncorrectIcon.vue';

export default {
    name: 'QuestionTrueFalseViewOnly',
    components: {
        CorrectIncorrectIcon,
    },
    props: {
        question: {
            required: true,
        },
    },
};
</script>
